import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { NameDayGridObject, NameDayObject } from '@libs/types/src/list/object-type/name-day.object';
import { NameDayCreateInput } from '@libs/types/src/list/input-type/name-day-create.input';
import { NameDayUpdateInput } from '@libs/types/src/list/input-type/name-day-update.input';
import { nameDayFrag } from '../types/name-day.types';

@Injectable({ providedIn: 'root' })
export class ListNameDayService extends GqlServiceV2 {

    public getListNameDays(input: GridInput, frag = nameDayFrag) {
        return this.query<NameDayGridObject>(
            `
                query($input: GridInput!) {
                    nameDay {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createListNameDay(input: NameDayCreateInput, frag = nameDayFrag) {
        return this.mutate<NameDayObject>(
            `
                mutation($input: NameDayCreateInput!) {
                    nameDay {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateListNameDay(input: NameDayUpdateInput, frag = nameDayFrag) {
        return this.mutate<NameDayObject>(
            `
                mutation($input: NameDayUpdateInput!) {
                    nameDay {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteListNameDay(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    nameDay {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
